<template>
    <send-list-form
        v-bind="$props"
        @updated="onUpdated"
    ></send-list-form>
</template>

<script>
  import CreateSendListFormWrapper from "../send-list-create/form-wrapper";
  import SendListForm from "../../components/send-list/form";

  export default {
    extends: CreateSendListFormWrapper,
    components: {
      SendListForm,
    },

    methods: {
      onUpdated({model, redirect, message}) {
        message && this.$message(message);
        this.$root.$emit('send-list-update', _.assign({}, this.model));
      },
    },

    mounted() {
      this.introMessage && this.$message(this.introMessage);
    },
  }
</script>

